<!--
Author: TangChen
Date: 2018-11-17
Desc: 设置适当性弹窗组件，为公共组件
 -->
<template>
    <div class="comp-msg-dialog comp">
        <el-dialog
            :title="privateInfo.tit"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <div class="prompt-info">
                    <p class="clear">
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span v-text="privateInfo.msg" />
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="108px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                        <el-input v-model="ruleForm.pwd" type="password" :maxlength="20" />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="privateInfo.btn2" v-on:click="dialogVisible = false">
                    {{ privateInfo.btn2 }}
                </el-button>
                <el-button type="primary" v-on:click="btnAgree">
                    {{ privateInfo.btn1 ? privateInfo.btn1 : "确认" }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "MsgDialog",
    props: {
        privateInfo: {
            type: Object,
            default: () => {
                return {};
            }
        },
        dialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            isPwdCheck: false,
            ruleForm: {
                pwd: ""
            },
            fundAll: {},
            rules: {
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            }
        };
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                this.$emit("event-fn", false);
            }
        }
    },
    mounted() {
        // 密码校验
        if (this.privateInfo.way && this.privateInfo.way.indexOf(",") > -1) {
            const _x = this.privateInfo.way.split(",");
            this.isPwdCheck = this.$cache.getPwdCheck(_x[0]) || this.$cache.getPwdCheck(_x[1]);
        } else {
            this.isPwdCheck = this.$cache.getPwdCheck(this.privateInfo.way);
        }
        this.dialogVisible = this.dialog;
    },
    methods: {
        btnAgree() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.fundAll.tpasswd = this.$util.enc(this.ruleForm.pwd);
                    this.dialogVisible = false;
                    const _x = Object.assign({}, this.privateInfo, this.fundAll);
                    this.$emit("event-fn", _x);
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-msg-dialog {
    .prompt-info {
        .el-icon-warning {
            color: $color-a;
            margin-right: 8px;
            font-size: $f24;
            vertical-align: middle;
        }
        span {
            float: right;
            display: inline-block;
            width: 405px;
        }
    }
}
</style>
